/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CompensationSettings {
    angular.module("meevo.plugins.compensationSettings", []);
}